/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { useTheme } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

const StyledTableRow = styled(
  ({ selected, openedRoute, row, theme, ...props }) => <TableRow {...props} />
)`
  ${(props) => {
    if (props.selected) {
      return `background-color: ${props.theme.palette.primary.hover} !important;`;
    } else {
      return `
        &:nth-of-type(odd) {
          background-color: ${props.theme.palette.primary.lighter} !important;
        }
      
        &:nth-of-type(even) {
          background-color: white !important;
        }
      
        &:hover {
          cursor: pointer;
          background-color: ${props.theme.palette.primary.hover} !important;
        }
      `;
    }
  }}

  .styled-table-cell {
    text-align: left;
    height: 40px;
    background-color: inherit;

    &.sticky {
      position: sticky !important;
      top: 0;
      z-index: 85;
    }
  }
`;

const StyledTableCell = styled(TableCell)`
  border-bottom: none !important;
`;

const CarrierManagementRow = ({ row, setOpenedRow }) => {
  const theme = useTheme();

  const handleRowClick = () => {
    setOpenedRow(row);
  };

  return (
    <StyledTableRow
      onClick={handleRowClick}
      hover={true}
      theme={theme}
      tabIndex={-1}
      key={row.carrierId}
      row={row}
      data-testid={`carrier-management-row-${row.carrierId}`}
    >
      <StyledTableCell
        align="left"
        className="styled-table-cell"
        style={{ width: "50px" }}
      >
        {row.tierName}
      </StyledTableCell>
      <StyledTableCell
        align="left"
        className="styled-table-cell"
        style={{ wordBreak: "break-word", width: "150px" }}
      >
        {row.carrierName}
      </StyledTableCell>
      <StyledTableCell
        align="left"
        className="styled-table-cell"
        style={{ wordBreak: "break-word", width: "150px" }}
      >
        {row.contactFullName}
      </StyledTableCell>
      <StyledTableCell
        align="left"
        className="styled-table-cell"
        style={{ wordBreak: "break-word", width: "150px" }}
      >
        {row.email}
      </StyledTableCell>
      <StyledTableCell
        align="left"
        className="styled-table-cell"
        style={{ width: "100px" }}
      >
        {row.phone1}
      </StyledTableCell>
      <StyledTableCell
        align="left"
        className="styled-table-cell"
        style={{ width: "100px" }}
      >
        {row.phone2}
      </StyledTableCell>
      <StyledTableCell
        align="left"
        className="styled-table-cell"
        style={{ width: "100px" }}
      >
        {row.phone3}
      </StyledTableCell>
      <StyledTableCell
        align="left"
        className="styled-table-cell"
        style={{ width: "100px" }}
      >
        {row.associatedUsersCount}
      </StyledTableCell>
      <StyledTableCell
        align="left"
        className="styled-table-cell"
        style={{ width: "100px" }}
      >
        {row.organizationName}
      </StyledTableCell>
    </StyledTableRow>
  );
};

CarrierManagementRow.propTypes = {
  row: PropTypes.object.isRequired,
};

export default CarrierManagementRow;
